import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'

export type EnvironmentType = 'dev' | 'staging' | 'prod'

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {

    /**
     * Get the current environment type based on the environment configuration
     */
    getCurrentEnvironment(): EnvironmentType {
        if (environment.production) {
            return 'prod'
        }
        if (environment.apiUrl.includes('staging')) {
            return 'staging'
        }
        if (environment.apiUrl.includes('local')) {
            return 'dev'
        }
        return 'dev'
    }
    /**
     * Check if the current environment is production
     */
    isProduction(): boolean {
        return this.getCurrentEnvironment() === 'prod'
    }
}
